import isEmpty from 'lodash/isEmpty';

export default function filterByType(tabs, type) {
  if (type && tabs) {
    const filteredTabsList = tabs.filter(tab => tab['tab-type'] === type);
    return !isEmpty(filteredTabsList) ? filteredTabsList : tabs;
  }
  return tabs;
}

export { filterByType };
